const calculateInnerBoxDimensions = (imageWidth, imageHeight, containerWidth, containerHeight)=>{
    const imageAspectRatio = imageWidth / imageHeight;
    const containerAspectRatio = containerWidth / containerHeight;
    if (imageAspectRatio > containerAspectRatio) {
        const calculatedHeight = containerWidth / imageAspectRatio;
        return {
            width: containerWidth,
            height: calculatedHeight
        };
    }
    {
        const calculatedWidth = containerHeight * imageAspectRatio;
        return {
            width: calculatedWidth,
            height: containerHeight
        };
    }
};
export { calculateInnerBoxDimensions };
